import actions from "./actions";

const initState = {
  organizationsStatistics: [],
  organizationsDailyStatistics: [],
  organizationsByDatesStatistics: [],
  loading: false,
  dailyLoading: false,
};

const mergeByDatesData = (baseStats, byDatesStats) => {
  if (!byDatesStats || byDatesStats.length === 0) return baseStats;
  return baseStats.map((org) => {
    const byDates = byDatesStats.find(
      (d) => d.organizationId === org.organizationId
    );
    return {
      ...org,
      visitsByDates: byDates ? byDates.visits : null,
      ordersByDates: byDates ? byDates.orders : null,
      appendOrdersByDates: byDates ? byDates.appendOrders : null,
      myPosPaymentsByDates: byDates ? byDates.myPosPayments : null,
    };
  });
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_ORGANIZATIONS_STATISTICS_SUCCESS:
      return {
        ...state,
        organizationsStatistics: mergeByDatesData(
          action.organizationsStatistics,
          state.organizationsByDatesStatistics
        ),
      };
    case actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_ORGANIZATIONS_STATISTICS_DAILY_BY_DATE_REQUEST:
      return {
        ...state,
        dailyLoading: true,
      };
    case actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_SUCCESS:
      return {
        ...state,
        organizationsStatistics: mergeByDatesData(
          state.organizationsStatistics,
          action.organizationsByDatesStatistics
        ),
        organizationsByDatesStatistics: action.organizationsByDatesStatistics,
        loading: false,
      };
    case actions.GET_ORGANIZATIONS_STATISTICS_DAILY_BY_DATE_SUCCESS:
      return {
        ...state,
        organizationsDailyStatistics: action.organizationsDailyStatistics,
        dailyLoading: false,
      };

    default:
      return state;
  }
}
